import { defineMessages } from 'react-intl';

export const locale = defineMessages({
  title: {
    id: 'gdc.delete.title',
    description: 'Delete modal title',
    defaultMessage: 'Confirm delete'
  },
  cannotBeUndone: {
    id: 'gdc.delete.cannot-be-undone',
    description: 'Deletion is final and cannot be undone.',
    defaultMessage: 'Deletion is final and cannot be undone.'
  },
  cancel: {
    id: 'gdc.delete.cancel',
    description: 'Cancel deletion of discount code',
    defaultMessage: 'Cancel'
  },
  delete: {
    id: 'gdc.delete.delete',
    description: 'Delete discount code',
    defaultMessage: 'Delete'
  }
});
